import React from 'react'
import { compose } from 'hookompose'
//import 'products.bundle';

const Checkout = ({ lookup, n, d, history }) => (
  <div className="p16 f">
    <div className="fv pl32 w90">
      <h1>Checkout</h1>
    </div>
  </div>
)

export default compose()(Checkout)
